import { useCallback } from 'react';

import { Trash } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui'

import { ControlledConfirmationPopover } from '@Components/ConfirmationPopover';
import { useGrid } from '@Components/Grid';
import { getInfo } from '@Components/Grid/components/Table/formatters';

import { formatType } from './utils';

export default function DeleteFormatter({ info }) {
  const { definitions: { entityName }, events: { handleDelete } } = useGrid()

  const { row } = getInfo(info)
  const { id, status } = row

  const handleSubmit = useCallback(async () => {
    await handleDelete(id)
  }, [handleDelete, id])

  if (['to_process', 'processing', 'expired'].includes(status)) {
    return null
  }

  return <>
    <ControlledConfirmationPopover
      target={<DefaultTooltip content='Delete' side='left'><Trash size={16} /></DefaultTooltip>}
      title={<span>Delete {entityName.toLowerCase()} <i>{`[#${row.id}] / ${formatType(row.dataType)}`}</i></span>}
      onSubmit={handleSubmit}
    >
      <p><strong>Are you sure you want do this?</strong></p>
    </ControlledConfirmationPopover>
  </>
}
